import { useCallback, useState } from 'react';

/**
 * Estado colapsado/expandido de un menú lateral, persistido en localStorage.
 *
 * Desde T-2 hay UN SOLO menú (components/layout/Sidebar), pero conserva una clave por zona
 * (`variant`): plegarlo en el portal no debe plegarlo en /app, y viceversa.
 *
 * El estado NUNCA se refleja como clase en <body>: vive en el propio <nav> (`.side-nav--collapsed`)
 * para que el CSS de una zona no pueda plegar el menú de la otra.
 */
export function useSidebarCollapsed(storageKey: string): [boolean, () => void] {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(storageKey) === 'true';
    } catch {
      return false;
    }
  });

  const toggle = useCallback(() => {
    setCollapsed(prev => {
      const next = !prev;
      try { localStorage.setItem(storageKey, String(next)); } catch { /* sin almacenamiento */ }
      return next;
    });
  }, [storageKey]);

  return [collapsed, toggle];
}
